"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
/**
 * Thrown when an argument is invalid because of: type, value or intention
 * @param {string} argumentName
 * @param {string} explanation
 */
class InvalidArgumentError extends ExtendableError_1.default {
    constructor(argumentName, explanation = '') {
        super(`Invalid '${argumentName}' argument. ${explanation}`);
        this.argumentName = argumentName;
        this.explanation = explanation;
        this.argumentName = argumentName;
    }
}
exports.default = InvalidArgumentError;
